import React, { Component } from "react";
import { observer } from "mobx-react";

import { Icon } from "@formant/ui/component/common/Icon";
import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import { IBaseModuleProps } from "../IBaseModuleProps";
import { Module } from "../Module";
import * as styles from "./index.scss";

@observer
export class PlaceHolderModule extends Component<IBaseModuleProps> {
    render() {
        const { streamName } = this.props;
        const name = streamName.split(":")[1];
        return (
            <Module
                {...this.props}
                streamName={name}
                type={this.props.streamType}
                className={styles["placeholder-module"]}
                displayName={this.props.layoutModule?.configuration?.customName}
                icon={<Icon name="ros" />}
            >
                <LoadingIndicator visible={true} className={styles.loader} />
                <div className={styles.message}>
                    Just a moment while we prepare the module.
                    <br />
                    This could take a minute...
                </div>
            </Module>
        );
    }
}
